import '@ant-design/v5-patch-for-react-19'
import './styles.css'

import { Provider } from 'react-redux'

import store from '~/common/store'
import StyledLayout from '~/Layout'
import { AppProvider } from '~/state/appContext'

function SalesCalculator({ Component, pageProps }) {
  return (
    <AppProvider>
      <Provider store={store}>
        <StyledLayout Component={Component} pageProps={pageProps} />
      </Provider>
    </AppProvider>
  )
}

export default SalesCalculator
